module.exports = __webpack_public_path__ + "static/media/cm2.c718a551.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cm2.png
// module id = 112
// module chunks = 0